__turbopack_context__.v({
  "delta": "AnimatedCount-module__TYudFq__delta",
  "deltaFloat": "AnimatedCount-module__TYudFq__deltaFloat",
  "highlight": "AnimatedCount-module__TYudFq__highlight",
  "metricPulse": "AnimatedCount-module__TYudFq__metricPulse",
  "wrapper": "AnimatedCount-module__TYudFq__wrapper",
});
